import {resource} from './resource';

export const queryClientHelpers = resource.createQueryClientHelpers();
export {useListItem, useListItems, useNextListItem} from './queries';
export {resource};
